import React, { useRef } from 'react';
import './VeiculoseciaCarousel.scss';

import Slider from 'react-slick';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

function VeiculoseciaCarousel() {
    const sliderRef = useRef(null);

    return (
        <div className='carousel'>
            <div className='carousel__button'>
                <button
                    className='arrow__prev'
                    onClick={() => { sliderRef.current.slickPrev(); }}
                >
                    <MdKeyboardArrowLeft className='arrow__icon' />
                </button>
                <button
                    className='arrow__next'
                    onClick={() => { sliderRef.current.slickNext(); }}
                >
                    <MdKeyboardArrowRight className='arrow__icon' />
                </button>
            </div>
            <div className='carousel__slider'>
                <Slider
                    ref={sliderRef}
                    slidesToShow={1}
                    slidesToScroll={1}
                    infinite={true}
                    autoplay={true}
                    dots={false}
                    speed={500}
                    autoplaySpeed={6000}
                    pauseOnHover={true}
                >
                    <div className='carousel__one'>
                        <div className='carousel__container'>
                            <div className='carousel__information'>
                                <p className='carousel__title'>
                                    SONHANDO COM O SEU CAMINHÃO?
                                </p>
                                <span className='carousel__text'>
                                    Aqui seu sonho se torna realidade! Todas as ofertas com garantia de procedência.
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className='carousel__two'>
                        <div className='carousel__container'>
                            <div className='carousel__information'>
                                <p className='carousel__title'>
                                    MAIS DE 16 ANOS NO MERCADO
                                </p>
                                <span className='carousel__text'>
                                    Fale com a gente! Temos os melhores veículos, as melhores taxas e ótimas condições de pagamento...
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className='carousel__three'>
                        <div className='carousel__container'>
                            <div className='carousel__information'>
                                <p className='carousel__title'>
                                    VEÍCULOS E CIA MT
                                </p>
                                <span className='carousel__text'>
                                    Aqui a satisfação e a certeza de bons negócios são garantidas!
                                </span>
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>
        </div>
    )
}

export default VeiculoseciaCarousel;
